export default __webpack_public_path__ + "static/media/close-48.de0dc9b7.svg";